export default __webpack_public_path__ + "static/media/medication.0e6a943d.png";